// Спільні типи копіювання пропозицій для NewTenderStageBtn.vue і CopyTender.vue
export const COPY_OFFERS_TYPES = {
  NONE: 'NONE',
  ALL: 'ALL',
  SELECTED: 'SELECTED'
}

export default {
  data() {
    return {
      blockByTenderCriterias: false, // Блокируем копирование, если в формуле используется тендерные критерии (бек вылетает)
      copy_offers: COPY_OFFERS_TYPES.NONE,
      copy_offers_files: true,
    }
  },
  computed: {
    blockCopy() {
      return this.blockByTenderCriterias && !!(this.tender.bids?.length || this.tender.bidsCount) && this.copy_offers === 'SELECTED'
    },
    // Тендер з обов'язковими вкладеннями - вкладення завжди копіюються, вибір заборонений
    $_mustCopyAttachments() {
      return !!this.tender?.requiedAttachments
    },
  },
  methods: {
    /**
     * Проверяет формулу критериев тендера на использование тендерных критериев
     * Блокирует копирование если тендерные критерии используются в формуле приведенной цены
     */
    async checkFormula() {
      // Копируем из списка тендеров без полной информации - блокируем копирование позиций
      if (!this.tender?.criteriaCard) {
        return
      }

      await this.$store.dispatch('infoAboutCriterionCard', { save: true, id: this.tender.criteriaCard })
        .then(criteryCard => {
          if (!criteryCard?.criterias?.length || !criteryCard?.reducedPriceFormula) {
            this.blockByTenderCriterias = false
            return
          }

          // Получаем коды критериев уровня TENDER
          const formulaCodes = criteryCard.criterias
            .filter(i => i.criterionBindingLevel === 'TENDER' && i.formulaCode)
            .map(i => i.formulaCode)

          // Проверяем использование тендерных критериев в формуле приведенной цены
          this.blockByTenderCriterias = formulaCodes.some(code => {
            const regex = new RegExp(`\\b${code}\\b`)
            return regex.test(criteryCard.reducedPriceFormula)
          })
        })
    },
    /**
     * Коли обрано "копіювати всі" — довантажує пропозиції тендеру (якщо їх ще нема)
     * і формує список активних пропозицій для копіювання. Інакше повертає bids як є
     * (пропозиції, обрані вручну через SelectOffersForCopy)
     */
    async $_resolveBidsForCopy(tender, bids = []) {
      if (this.copy_offers !== COPY_OFFERS_TYPES.ALL) {
        return bids
      }

      if (!tender.bids?.length) {
        await this.$store.dispatch('getTenderItem', { id: this.tender.tenderId })
          .then(res => { tender.bids = res.bids })
      }

      return tender.bids
        .map(i => i.bidDetails)
        .flat()
        .filter(i => i.bidStatus === 'ACTIVE')
        .map(i => ({
          id: i.id,
          copy_attachments: this.copy_offers_files
        }))
    },
    $_mapBidsToCopyModel(bids) {
      return bids.map(bid => ({
        bidId: bid.id,
        copyAttachments: this.$_mustCopyAttachments || !!bid.copy_attachments
      }))
    },
    /**
     * Помилку REQUIRED_ATTACHMENTS_MUST_BE_COPIED (і інші відомі errorCode) від
     * /copy та /copyAsNewStage мапимо в локалізований текст, бек віддає message лише українською
     */
    $_getCopyErrorMessage(error) {
      const code = error?.graphQLErrors?.[0]?.extensions?.code
      if (code && this.$t(`Errors.${code}`) !== `Errors.${code}`) {
        return this.$t(`Errors.${code}`)
      }
      return error?.message || error
    },
  },
}
